<h2 mat-dialog-title>
  {{ 'general.selectColumns' | translate }}
</h2>
<mat-dialog-content class="modal-content">
  <h4>{{ 'general.selectColumnsMsg' | translate }}</h4>
  @for (column of modalColumns; track column) {
    <div class="modal-content-row">
      @if (column.text !== data.translatePfx + '.actions') {
        <mat-checkbox
          class="modal-content-item"
          [labelPosition]="after"
          [(ngModel)]="column.value"
          >{{ column.text | translate }}</mat-checkbox
          >
        }
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="cancel-button" mat-stroked-button (click)="onNoClick()">
      {{ 'general.cancel' | translate }}
    </button>
    <button
      id="save-button"
      mat-stroked-button
      color="primary"
      [mat-dialog-close]="modalColumns"
      cdkFocusInitial
      >
      {{ 'general.save' | translate }}
    </button>
  </mat-dialog-actions>
